const SUCCESS = "success";
const ERROR = "error";
const DEFAULT_MESSAGE = "Something Wrong";
export {ERROR, SUCCESS, DEFAULT_MESSAGE}